import QRCode from 'qrcode.react';
import React, {
	useEffect, useMemo, useRef, useState,
} from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { firebase } from '../components/Firebase';
import Logo from '../components/Logo';
import { Gallery } from '../components/Gallery';

const DesktopPage = () => {
	const { roomId } = useParams();
	const history = useHistory();
	const roomRef = useMemo(() => (roomId
		? firebase.roomById(roomId) : firebase.createNewRoom()),
	[]);
	const [room, setRoom] = useState(null);

	const onValueChange = (res) => {
		if (res) {
			if (roomId) {
				const data = res.toJSON();
				console.log(data);
				setRoom(data);
			} else {
				history.push(`/desktop/${res.key}`);
			}
		}
	};

	useEffect(() => {
		roomRef.on('value', onValueChange);

		return () => {
			roomRef.off('value', onValueChange);
		};
	}, []);

	const scrollPosition = useRef(0);

	// scrolling
	// eslint-disable-next-line consistent-return
	useEffect(() => {
		if (room?.direction) {
			const interval = setInterval(() => {
				const element = document
					.getElementsByClassName('ReactVirtualized__Collection')
					.item(0);
				if (element) {
					scrollPosition.current = element.scrollLeft + (100 * (room?.direction ?? 0));
					element.scroll({
						left: scrollPosition.current,
						behavior: 'smooth',
					});
				}
			}, 40);

			return () => clearInterval(interval);
		}
	}, [room?.direction]);

	return room ? (
		<div>
			{
				(!room?.inUse) ? (
					<>
						<Logo />
						<div id="qrcode">
							<QRCode
								size={200}
								value={`${window.location.origin}/mobile/${roomId}`}
								bgColor="#FFFFFF"
								fgColor="#D56800"
							/>
						</div>
					</>
				) : (
					<>
						<span>
							Mobile connected in
							{` ${room.mode || 'portrait'} `}
							mode!
						</span>
						<Gallery mode={room.mode} />
					</>
				)
			}
			<span>{roomRef.key}</span>
			<span>{room.timeMade}</span>
		</div>
	) : (<Logo />);
};

export default DesktopPage;
